import { Pipe, PipeTransform } from '@angular/core';
import * as _ from 'underscore';

@Pipe({
    name: 'search',
    standalone: false
})
export class FilterSearchPipe implements PipeTransform {

    transform(listToFilter: any[], searchText: string, field?: string, method = 'includes'): any[] {
        if (!listToFilter) { return []; }
        if (!searchText) { return listToFilter; }
        if (!field) {

            return listToFilter.filter(element => {
                return _.find(Object.keys(element), (key) => {
                    if (!!element[key] && (typeof element[key] === 'string' || typeof element[key] === 'number')) {
                        return element[key].toString().toLowerCase()[method](searchText);
                    } else if (element[key] instanceof Object) {
                        return _.find(Object.keys(element[key]), (subKey) => {
                            if (!!element[key][subKey] && (typeof element[key][subKey] === 'string'
                                || typeof element[key][subKey] === 'number')) {
                                return element[key][subKey].toString().toLowerCase()[method](searchText);
                            }
                        });
                    }
                });
            });
        }
        if (!!field) {
            searchText = searchText.toLowerCase();
            return listToFilter.filter(element => {
                return element[field].toString().toLowerCase()[method](searchText);
            });


        }
    }
}
